// extracted by mini-css-extract-plugin
export var container = "_ix-1";
export var editor = "_ix-2";
export var resizable = "_ix-3";
export var wrapper = "_ix-0";